import { EditorNode } from '../core/EditorNode';

export class TagNode extends EditorNode {
  constructor() {
    super('tag');
  }

  render(data, context) {
    const { makeDraggable } = context;
    const { id, label, color } = data;

    const tagEl = document.createElement('span');
    tagEl.contentEditable = 'false';
    tagEl.setAttribute('data-type', 'tag');
    tagEl.setAttribute('data-tag-id', id);
    tagEl.setAttribute('data-label', label);
    tagEl.setAttribute('data-value', '');

    tagEl.className = this.getClassName(color);

    if (makeDraggable) {
      makeDraggable(tagEl);
      tagEl.classList.add('cursor-grab', 'draggable-item');
    }

    tagEl.innerHTML = `<span class="pointer-events-none">#${label}</span>`;
    return tagEl;
  }

  update(element, data, context) {
    const parent = element.parentNode;
    if (!parent) return;

    const newNode = this.render(data, context);
    parent.replaceChild(newNode, element);
  }

  getClassName(color) {
    const colorMap = {
      blue: 'bg-blue-100/60 text-black/80 ring-blue-200/60 hover:bg-blue-100/80',
      purple: 'bg-violet-100/60 text-black/80 ring-violet-200/60 hover:bg-violet-100/80',
      green: 'bg-emerald-100/60 text-black/80 ring-emerald-200/60 hover:bg-emerald-100/80',
      orange: 'bg-amber-100/60 text-black/80 ring-amber-200/60 hover:bg-amber-100/80',
      pink: 'bg-pink-100/60 text-black/80 ring-pink-200/60 hover:bg-pink-100/80',
      red: 'bg-rose-100/60 text-black/80 ring-rose-200/60 hover:bg-rose-100/80',
      indigo: 'bg-indigo-100/60 text-black/80 ring-indigo-200/60 hover:bg-indigo-100/80',
      teal: 'bg-teal-100/60 text-black/80 ring-teal-200/60 hover:bg-teal-100/80',
    };
    return `inline-flex items-center gap-1 mx-0.5 px-2.5 py-0.5 rounded-full text-[13px] font-medium ring-1 ring-inset select-none align-middle cursor-grab draggable-item transition-all duration-200 ${
      colorMap[color] || colorMap.blue
    }`;
  }

  serialize(element) {
    const tagId = element.getAttribute('data-tag-id');
    const value = element.getAttribute('data-value') || '';
    return `[[tag:${tagId}:${value}]]`;
  }
}
